var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5261_10273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.2001V7.79987C9 7.18347 9.60803 6.79941 10.0922 7.11L16.6397 11.3101C17.1201 11.6183 17.1201 12.3817 16.6397 12.6899L10.0922 16.89C9.60803 17.2006 9 16.8165 9 16.2001Z",
    fill: "#B7D2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.63636C17.7164 1.63636 22.3636 6.28364 22.3636 12C22.3636 17.7164 17.7164 22.3636 12 22.3636C6.28364 22.3636 1.63636 17.7164 1.63636 12C1.63636 6.28364 6.28364 1.63636 12 1.63636ZM12 0C5.36727 0 0 5.36727 0 12C0 18.6327 5.36727 24 12 24C18.6327 24 24 18.6327 24 12C24 5.36727 18.6327 0 12 0Z",
    fill: "#B7D2D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5261_10273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.61a61e514a515c274b64ace164eee139.svg";
export { ForwardRef as ReactComponent };